"use client";

import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";

const OpenDematFloatBannerSkeleton = () => {
  return (
    <>
      <div
        className="fixed bottom-0 left-0 z-99999 hidden min-h-[73px] max-h-[88px] w-screen shadow-[-4px_-4px_6px_#00000014] md:flex"
        aria-live="polite"
      >
        <div className="bg-[#eff2ff]">
          <BFLSkeleton width={230} height={50} classes="w-full h-full object-fill" />
        </div>

        <div className="flex shrink grow items-center justify-between bg-white px-6 py-4">
          <div className="text-container fw-500">
            <div className="relative flex items-center text-base font-medium text-black">
              <span className="inline-block rounded-[6px] bg-[#ebebeb] text-transparent">
                Start your trading journey with Bajaj Broking
              </span>
              <BFLSkeleton
                width="100%"
                height={24}
                classes="absolute inset-0"
                borderRadius={6}
              />
            </div>
            <div className="relative text-xs font-medium text-gray-600">
              <BFLSkeleton
                width="100%"
                height={16}
                classes="absolute inset-0"
                borderRadius={6}
              />
            </div>
          </div>

          <button
            className="demat-button relative h-[40px] w-[220px] cursor-pointer rounded-[20px] px-4 py-2 text-sm"
            type="button"
            aria-label="Open Demat Account"
          >
            <div className="flex items-center gap-1 opacity-0">
              <div className="flex">
                <i className="icomoon animated-button text-xs before:content-['\e911']"></i>
                <i className="icomoon animated-button text-xs before:content-['\e911']"></i>
                <i className="icomoon animated-button text-xs before:content-['\e911']"></i>
              </div>
            </div>
            <BFLSkeleton
              width="100%"
              height={40}
              classes="!absolute inset-0 !block"
              borderRadius={20}
            />
          </button>
        </div>

        <button
          className="bg-lgray-200 flex min-h-[73px] w-[73px] cursor-pointer items-center justify-center"
          aria-label="Close banner"
          type="button"
        >
          <span className="relative inline-flex items-center justify-center">
            <i className="icomoon text-[20px] opacity-0 before:content-['\e914']"></i>
            <BFLSkeleton
              width={20}
              height={20}
              classes="absolute inset-0"
              borderRadius={4}
            />
          </span>
        </button>
      </div>
      <div className="fixed bottom-[80px] right-[20px] z-9 block md:hidden" aria-hidden="true">
        <div className="demat-button relative h-[40px] w-max cursor-default rounded-[20px] px-4 py-2 text-sm">
          <div className="flex items-center gap-1 opacity-0">
            <span className="whitespace-nowrap">OPEN DEMAT ACCOUNT</span>
          </div>
          <BFLSkeleton
            width="100%"
            height={40}
            classes="!absolute inset-0 !block"
            borderRadius={20}
          />
        </div>
      </div>
    </>
  );
};

export default OpenDematFloatBannerSkeleton;

